import { InlineTextButton, Menu, MenuContent, MenuItem, MenuLabel } from '../../../components';

import { FormattedMessage } from 'react-intl';
import { LISTING_STATUS } from '../../../constants/listing.constants';
import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_DRAFT,
  LISTING_STATE_PUBLISHED,
} from '../../../util/types';
import MenuIcon from './MenuIcon';

import css from './ManageListingCard.module.css';

const LISTING_STATE_TO_ACTIONS = {
  [LISTING_STATE_DRAFT]: [],
  [LISTING_STATE_PUBLISHED]: [
    {
      status: LISTING_STATUS.UNAVAILABLE,
      label: <FormattedMessage id="ManageListingCard.markAsUnavailable" />,
    },
    {
      status: LISTING_STATUS.UNDER_NEGOTIATION,
      label: <FormattedMessage id="ManageListingCard.markAsUnderNegotiation" />,
    },
    {
      status: LISTING_STATUS.SOLD,
      label: <FormattedMessage id="ManageListingCard.markAsSold" />,
    },
    {
      status: LISTING_STATUS.CANCELED,
      label: <FormattedMessage id="ManageListingCard.markAsCanceled" />,
    },
  ],
  [LISTING_STATE_CLOSED]: [
    {
      status: LISTING_STATUS.FOR_SALE,
      label: <FormattedMessage id="ManageListingCard.markAsForSale" />,
    },
    {
      status: LISTING_STATUS.UNDER_NEGOTIATION,
      label: <FormattedMessage id="ManageListingCard.markAsUnderNegotiation" />,
    },
    {
      status: LISTING_STATUS.SOLD,
      label: <FormattedMessage id="ManageListingCard.markAsSold" />,
    },
    {
      status: LISTING_STATUS.CANCELED,
      label: <FormattedMessage id="ManageListingCard.markAsCanceled" />,
    },
  ],
};
const LISTING_STATUS_TO_ACTIONS = {
  [LISTING_STATUS.DRAFT]: LISTING_STATE_TO_ACTIONS[LISTING_STATE_DRAFT],
  [LISTING_STATUS.FOR_SALE]: LISTING_STATE_TO_ACTIONS[LISTING_STATE_PUBLISHED],
  [LISTING_STATUS.UNAVAILABLE]: LISTING_STATE_TO_ACTIONS[LISTING_STATE_CLOSED],
  [LISTING_STATUS.UNDER_NEGOTIATION]: [
    {
      status: LISTING_STATUS.FOR_SALE,
      label: <FormattedMessage id="ManageListingCard.markAsForSale" />,
    },
    {
      status: LISTING_STATUS.UNAVAILABLE,
      label: <FormattedMessage id="ManageListingCard.markAsUnavailable" />,
    },
    {
      status: LISTING_STATUS.SOLD,
      label: <FormattedMessage id="ManageListingCard.markAsSold" />,
    },
    {
      status: LISTING_STATUS.CANCELED,
      label: <FormattedMessage id="ManageListingCard.markAsCanceled" />,
    },
  ],
  [LISTING_STATUS.SOLD]: [],
  [LISTING_STATUS.CANCELED]: [],
};

const ManageListingStatus = props => {
  const { currentListing, onListingStatusChange, disableActions } = props;
  const { state, publicData } = currentListing.attributes;
  const { status } = publicData || {};

  const actions = !!status ? LISTING_STATUS_TO_ACTIONS[status] : LISTING_STATE_TO_ACTIONS[state];

  if (actions.length === 0 || disableActions) {
    return null;
  }

  return (
    <div className={css.menubarWrapper}>
      <div className={css.menubarGradient} />
      <div className={css.menubar}>
        <Menu contentPlacementOffset={8} contentPosition="left">
          <MenuLabel className={css.menuLabel} isOpenClassName={css.listingMenuIsOpen}>
            <div className={css.iconWrapper}>
              <MenuIcon />
            </div>
          </MenuLabel>
          <MenuContent rootClassName={css.menuContent}>
            {actions.map(action => (
              <MenuItem key={action.status}>
                <InlineTextButton
                  type="button"
                  rootClassName={css.menuItem}
                  onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    onListingStatusChange(currentListing.id, action.status, state);
                  }}
                >
                  {action.label}
                </InlineTextButton>
              </MenuItem>
            ))}
          </MenuContent>
        </Menu>
      </div>
    </div>
  );
};

export default ManageListingStatus;
